import { EstadisticasSector, Sector } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroSectoresState extends CommonState<Sector> {
    estadisticas: Record<number, EstadisticasSector>;

    isLoadingEstadisticas: boolean;
    successLoadingEstadisticas: boolean | undefined;
    failOnLoadingEstadisticas: boolean;
}

export const TurneroSectoresUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    estadisticas: {},

    isLoadingEstadisticas: false,
    successLoadingEstadisticas: undefined,
    failOnLoadingEstadisticas: false
};
